import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";

import { loginRequest } from "../authConfig";
import { getMyRecruitmentRequests } from "../graph";
import { ModalViewDetailsRequest } from "./ModalViewDetailsRequest";
import { ModalStarterDetails } from "./ModalStarterDetails";
import { formatter } from '../helper/string';

import "../styles/RecruitmentRequests.css";

/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const RecruitmentRequests = (props) => {
    const { instance, accounts } = useMsal();
    const [ recruitmentRequests, setRecruitmentRequests ] = useState(null);
    const [ requestSelected, setRequestSelected ] = useState(null);
    const [ editableMode, setEditableMode ] = useState(false);
    const [ showNewSarterForm, setShowNewSarterForm ] = useState(false);
    const [ showRecruitmentRequestDetails, setShowRecruitmentRequestDetails ] = useState(false);

    const getRecruitmentRequests = async() => {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            getMyRecruitmentRequests(response.accessToken).then(response => {
                setRecruitmentRequests(response && response.recruitmentRequests ? response.recruitmentRequests : []);
            });
        });
    };

    useEffect(() => {
        getRecruitmentRequests();
    }, []);

    const rowClicked = (request) => {
        if (request.status !== 'Details Added') {
            setShowRecruitmentRequestDetails(true);
            setRequestSelected(request);
        }
    };

    const triggerStarterModal = (e, request) => {
        e.stopPropagation();
        setShowNewSarterForm(true);
        setRequestSelected(request);
    };

    const createRequest = () => {
        setShowRecruitmentRequestDetails(true);
        setRequestSelected(null);
        setEditableMode(true);
    };

    const closeRecruitmentRequest = () => {
        setShowRecruitmentRequestDetails(false);
        setRequestSelected(null);
        setEditableMode(false);
    };

    const closeStarterDetails = () => {
        setShowNewSarterForm(false);
        setRequestSelected(null);
    };

    const printStatus = (request) => {
        switch (request.status) {
            case 'Recruitment Approved':
                return <Button className="button-starter" onClick={(e) => triggerStarterModal(e, request)}>Details required</Button>;
            case 'Recruitment Declined':
                return 'Declined';
            case 'Details Added':
                return 'Processing...';
            default:
                return request.status;
        }
    };

    return recruitmentRequests && (
        <>
            <div className={`recruitmentRequests ${recruitmentRequests.length > 0 ? '' : 'none'}`}>
                <div className="title">
                    <span>{`Recruitment Requests ${recruitmentRequests.length > 0 ? 'Open' : ''}`}</span>
                    <Button variant="warning" className="ml-auto" onClick={createRequest}>New</Button>
                </div>
                <div className="content">
                    { recruitmentRequests.length > 0 ? (
                        <>
                            <div className="header">
                                <span>Position to fill</span>
                                <span>Department</span>
                                <span className="tablet-up">Work type</span>
                                <span className="tablet-up">Contract type</span>
                                <span className="desktop-up">Income type</span>
                                <span className="desktop-up">Salary range</span>
                                <span>Status</span>
                            </div>
                            { recruitmentRequests.map((request) => (
                                 <div key={request.id} className="request" onClick={() => rowClicked(request)}>
                                    <span>{ request.position }</span>
                                    <span>{ request.department }</span>
                                    <span className="tablet-up">{ request.workPlace }</span>
                                    <span className="tablet-up">{ request.contractType }</span>
                                    <span className="desktop-up">{ request.incomeType }</span>
                                    <span className="desktop-up">{`${formatter.format(request.salaryFrom)} - ${formatter.format(request.salaryTo)} per ${ request.salaryTimeFrame }`}</span>
                                    <span>{ printStatus(request) }</span>
                                </div>
                            ))}
                        </>
                    ) : (
                        <span>There is not any recruitment request open at the moment</span>
                    )}
                </div>
            </div>
            <ModalViewDetailsRequest onRequestCreated={getRecruitmentRequests} department={props.department} editable={editableMode} show={showRecruitmentRequestDetails} request={requestSelected} onClose={closeRecruitmentRequest} />
            <ModalStarterDetails onNewStarterAdded={getRecruitmentRequests} department={props.department} show={showNewSarterForm} request={requestSelected} onClose={closeStarterDetails} />
        </>
    );
};